<template>
    <section id="sessions" class="gh-section gh-schedule">
        <div class="gh-schedule-header">
            <div class="container" style="padding-bottom: 0">
                <h3 class="gh-section-heading gh-blue">2022 Live Schedule &amp; Sessions</h3>
                <div class="gh-div-btn">
                    <a class="gh-button gh-button--primary gh-button-outline"
                        href="/documents/MHA-UK-SPS-Schedule-2022.pdf" target="_blank">Download Schedule</a>
                </div>
                <el-row class="gh-tabs">
                    <el-col :span="8" class="gh-col">
                        <div class="gh-tab" @click="changeDay('2022-09-10')"
                            :class="(day ==='2022-09-10')? 'gh-blue selected' : 'gh-medgrey'">
                            <p class="gh-day">Day 1 </p>
                            <p class="gh-date"> (Sep 10)<span class="mobile-hide "></span></p>
                        </div>
                    </el-col>
                    <el-col class="gh-col" :span="8">
                        <div class="gh-tab" @click="changeDay('2022-09-11')"
                            :class="(day ==='2022-09-11')? 'gh-blue selected' : 'gh-medgrey'">
                            <p class="gh-day">Day 2 </p>
                            <p class="gh-date"> (Sep 11)</p>
                        </div>
                    </el-col>
                    <!-- <el-col class="gh-col" :span="8">
                        <div class="gh-tab" @click="changeDay('2022-08-21')"
                            :class="(day ==='2022-08-21')? 'gh-blue selected' : 'gh-medgrey'">
                            <p class="gh-day">Day 3 </p>
                            <p class="gh-date"> (Aug 21)</p>
                        </div>
                    </el-col> -->
                </el-row>
            </div>
        </div>

        <div class="gh-schedule-body pb-1">
            <div class="container pb-2">
                <div v-if="getSessionsByDate">
                      <div v-for="data in getSessionsByDate" :key="'session-' + data.id" class="gh-each-session">
                          <div @click="updateRow(data.id, $event)">
                              <el-row :id="'gh-row-' + data.id" :gutter="20" class="gh-row-header gh-session-1"
                                  :class="row===data.id ? 'selected' : ''">
                                  <el-col :xs="24" :md="5" class="gh-session-text gh-each-session-date">
                                      <span v-html="formatTime(data.time, row === data.id)"></span>
                                  </el-col>
                                  <el-col :xs="24" :md="12" class="gh-session-text gh-each-session-title">
                                      <span class="gh-schedule-session-title" v-html="data.title"></span>
                                  </el-col>
                                  <el-col :xs="0" :md="7" class="gh-session-text mobile-hide">
                                      <p class="gh-schedule-session-names"
                                          v-html="getSpeakerNamesById(data.speaker_id)"></p>
                                  </el-col>
                              </el-row>
                          </div>
                          <transition name="slide-fade" mode="out-in">
                              <el-row :gutter="30" class="gh-session-2" v-if="row === data.id">
                                  <el-col :xs="24" :md="5" class="gh-session-speakers">
                                      <div class="gh-session-speakers-row">
                                          <div class="gh-session-speakers-col"
                                              v-for="speakerId in stringToArray(data.speaker_id)"
                                              :key="'row-' + speakerId">
                                                  <img class="gh-speaker-image"
                                                      :src="'/images/suicidePreventionSummit/speakers/speaker-images'+getSpeaker(speakerId).id+'.jpg'"
                                                      alt="">
                                                  <p class="gh-speaker-title gh-darkgrey">{{ getSpeakerName(speakerId) }}</p>
                                                  <p class="gh-speaker-work">{{ getSpeakerCredentials(speakerId) }}</p>
                                          </div>
                                      </div>
                                  </el-col>
                                <el-col :xs="24" :md="19">
                                      <p class="gh-session-description gh-darkgrey" v-html="data.detail"></p>
                                  </el-col>
                              </el-row>
                          </transition>
                      </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
    import mixinDevice from '@/mixins/device'

    export default {
      mixins: [mixinDevice],

      data() {
        return {
          day: '2022-09-10',
          row: 0,
          event: null
        }
      },

      computed: {
        sessions() {
          return this.$store.state.event.eventSessions
        },

        speakers() {
          return this.$store.state.event.eventSpeakers
        },

        getSessionsByDate() {
          return this.sessions.filter(session => {
            return session.session_date === this.day
          })
        },

        isPartnerPage() {
          let routeName = this.$route.name
          if (routeName.includes('aca') || routeName.includes('aas')) {
            return true
          }

          return false
        }
      },

      methods: {
        stringToArray(str) {
          return str.split(',')
        },

        getSpeakerNamesById(ids) {
          const idsArray = this.stringToArray(ids)
          return '<span>' + this.speakers.map(speaker => {
            return idsArray.includes(speaker.id.toString()) ? speaker.name : ''
          }).filter(name => name !== '').join('</span><span>') + '</span>'
        },

        getSpeaker(id) {
          return this.speakers.filter(speaker => speaker.id === parseInt(id))[0]
        },

        getSpeakerName(id) {
          if (this.getSpeaker(id) && this.getSpeaker(id).name) {
            return this.stringToArray(this.getSpeaker(id).name)[0]
          }
        },

        getSpeakerCredentials(id) {
          return this.getSpeaker(id).work
        },

        formatTitle(title) {
          let titleArray = title.split(':');
          return titleArray.length > 1 ? `<span>${titleArray[0]}</span>: ${titleArray[1]}` : `<span>${title}</span>`
        },

        formatTime(time, selected) {
          let timeArray = time.split('(');
          return `<span>${timeArray[0]}</span> <span class="gh-timezone">(BST)</span>`
        },

        changeDay(day) {
          this.day = day
          this.row = 0
        },
        updateRow(id, event) {
          if (this.row === id) {
            this.row = 0
          } else {
            this.row = id
          }
        }
      }
    }
</script>

<style lang="scss" scoped>
    .gh-schedule {
      padding: 0;
      font-family: proxima-nova,sans-serif;
    }

    .gh-schedule-header {
      padding-top: 2rem;
      background: #F5F7FA;
    }

    .gh-schedule-body {
      background: #fff;
    }

    .gh-section-heading {
      font-weight: bold;
      font-size: 2.5rem;
      padding-bottom: .5rem;
    }

    .gh-div-btn {
      display: flex;
      align-items: center;
      justify-content: center;
      // margin-top: 3rem;
      .gh-button {
        padding: .8rem 3rem;
        @media (max-width: 768px) {
          margin-bottom: 20px;
        }
      }
    }

    .gh-session-speakers {
      margin-bottom: -1rem;

      .el-row {
        display: flex;
        flex-flow: row wrap;
      }
    }

    .gh-tabs {
      margin-top: 2rem;
      display: flex;
      justify-content: center;

      .gh-col {
        max-width: 365px;

        + .gh-col {
          margin-left: 1.5rem;
        }
      }

      .gh-tab {
        // border: 1px solid #CECECF;
        // border-radius: 5px;
        display: flex;
        flex-flow: row nowrap;
        align-items: center;
        text-align: center;
        justify-content: center;
        max-width: 100%;
        padding: 1rem 2rem;

        p {
          + p {
            margin-left: 1.5rem;
          }
        }

        &.selected {
          color: #f76c6c;

          &::after {
            position: absolute;
            content: '';
            width: 0;
            height: 0;
            border-width: 20px 20px 0 20px;
            border-color: #F5F7FA transparent transparent transparent;
            border-style: solid;
            bottom: -1rem;

            @media (max-width: 480px) {
              bottom: -2rem;
            }
          }
        }
      }

      .gh-day {
        line-height: 1;
        font-size: 1.5rem;
        font-weight: bold;
      }

      .gh-date {
        font-size: 1.5rem;
        font-weight: 500;
        margin-left: .5rem !important;
        font-weight: bold;
      }

      .el-col {
        text-align: center;
        cursor: pointer;
      }

      // .el-col .selected {
      //     padding-bottom: .5rem;
      //     border-bottom: 5px solid #4ba6f5;
      // }
    }

    .gh-row-header {
      cursor: pointer;

      span {
        font-weight: 600;
      }

      .gh-schedule-session-title {
        max-width: 500px;
        display: block;
        line-height: 1.2;
      }

      .gh-schedule-session-names {
        font-size: 1.5rem;
        font-weight: 400;

        span {
          line-height: 1;
          display: inline-block;

          + span {
            margin-top: .5rem;
          }
        }
      }

    }

    .gh-speaker-title {
      font-size: 1.2rem;
      line-height: 1;
      margin-top: 20px;
      font-weight: 600;
      margin-bottom: .3rem;
      color: #f76c6c;
    }

    .gh-speaker-work {
      color: #f76c6c;
      margin: 5px 1rem 1rem 0;
    }

    .gh-button {
      padding: 1rem 3rem;
      font-size: 1.2rem;
      font-weight: 900;
      border-radius: 5px;
      margin-top: 3rem;
    }

    .gh-session-text {
      font-size: 1.3rem;
      color: #474F59;

      ::v-deep(.gh-timezone) {
        font-weight: 400;
        color: #A3A7AC;
      }

      @media (max-width: 767px) {
        margin-bottom: 5px;
      }
      @media (min-width: 768px) {
        font-size: 1.3rem;
      }
    }

    .gh-each-session {
      padding: 1rem;
      border-bottom: 1px solid #868686;

      &:last-of-type {
        border-bottom: 0;
      }

      .gh-each-session-date, .gh-schedule-session-names {
        font-size: 1.3rem;
      }

      .selected {
        .gh-session-text {
          color: #f76c6c !important;
        }

        .gh-schedule-session-names {
          display: none !important;
        }
      }
    }

    .gh-session-1 {
      padding: 20px 0;

      @media (max-width: 678px) {
        padding-top: 0px;
      }

    }

    .gh-session-2 {
      padding: 10px 0 23px;
    }

    .gh-each-session .el-col {
      text-align: left;
    }

    .slide-fade-enter-active {
      transition: all .5s cubic-bezier(1.0, 0.5, 0.8, 1.0);
    }

    .slide-fade-enter, .slide-fade-leave-to {
      transform: translateX(10px);
      opacity: 0;
    }

    .gh-speaker-image {
      border-radius: 50%;
      width: 130px;
      height: 130px;
    }

    .gh-button-div {
      display: flex;
      align-items: center;
      justify-content: center;

      .gh-button {
        max-width: 50%;
        font-weight: 700;
        margin-bottom: 1rem;
      }
    }

    .gh-session-description {
      font-size: 1.1rem;
      font-weight: 500;
    }

    .gh-text-center {
      text-align: center;
      margin-top: 10px;
    }


    .gh-session-speakers-row {
      display: flex;
      flex-flow: row wrap;
      margin-top: 2rem;
      margin-left: -.3rem;

      .gh-session-speakers-col {
        padding: .3rem;

        .gh-speaker-work {
          max-width: 197px;
        }
      }
    }

    @media screen and (max-width: 1200px) {
      .gh-tabs {
        justify-content: center;
        display: flex;

        .gh-col {
          max-width: 340;
          display: flex;
          justify-content: center;

          + .gh-col {
            margin-left: 0;
          }
        }
      }

      .gh-speaker-image {
        width: 120px;
        height: 120px;
      }
    }

    @media screen and (max-width: 1023px) {
      .gh-section-heading {
        font-size: 2.2rem;
      }

      .mobile-hide {
        display: none;
      }

      .gh-speaker-image {
        display: none;
      }
    }

    @media screen and (max-width: 991px) {
      .gh-session-speakers {
        margin-top: -1rem;
        margin-bottom: 1rem;
      }
      .gh-tabs {
        .gh-tab {
          flex-flow: column;
          width: 100%;
          max-width: 263px;
          padding: .5rem 2rem;

          p {
            font-size: 1.35rem !important;
          }

          .gh-date {
            margin-left: 0 !important;
          }
        }
      }
    }

    @media screen and (max-width: 767px) {
      .pb-2 {
        padding-top: 0px;
      }

      .gh-section-heading {
        font-size: 2rem;
      }
    }

    @media screen and (max-width: 600px) {
      .gh-tabs {
        .gh-tab {
          max-width: 167px;
        }
      }
    }

    @media screen and (max-width: 480px) {
      .gh-tabs {
        .gh-tab {
          padding: .5rem 1rem;

          .gh-date {
            line-height: 1;
          }
        }
      }

      .gh-schedule-header {
        padding-bottom: 1rem;
      }

      .gh-schedule-body {
        padding-top: 1.5rem;
      }
    }

    @media screen and (max-width: 370px) {
      .gh-tabs {
        .gh-tab {
          padding: .5rem;
        }
      }
    }

</style>
<style lang="scss">
.gh-page-suicide-prevention {
  .gh-schedule {
    .gh-row-header {
      .gh-schedule-session-names {
        display: flex;
        flex-flow: column;

        span {
          line-height: 1;
          display: inline-block;

          + span {
            margin-top: .5rem;
          }
        }
      }
    }
  }
}
</style>
